import api from "./axiosConfig";
import { LogisticsFeeRequestItem } from "./models/LogisticsFeeRequest";
import { OfficeWorkOptionRequest, OfficeWorkRequest } from "./models/OfficeWorkRequest";
import { ProcessFeeOptionRequest, ProcessFeeRequestItem } from "./models/ProcessFeeRequest"
import { WrappingDeliveryOptionRequest, WrappingFeeRequestItem, WrappingSizeOptionRequest } from "./models/WrappingFeeRequest";
import { ShippingFeeRequestItem } from "./models/ShippingFeeRequest";
import { InvoiceContentRequest } from "./models/InvoiceContentRequest";

// STATUS HISTORY
export const getInvStatusHistory = async (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/history`);
}

// PROCESS FEE
export const getProcessFeeDetails = async (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/processFee`);
}

export const getProcessFeeOptions = async (invoiceMasterId: string) => {
  return api.get(`invoice/${invoiceMasterId}/processFee/processFeeOption`)
}

export const postProcessFeeOptions = async (invoiceMasterId: string, req: ProcessFeeOptionRequest) => {
  return api.post(`invoice/${invoiceMasterId}/processFee/processFeeOption`, req)
}

export const postProcessFee = (invoiceMasterId: string, processFee: ProcessFeeRequestItem[]) => {
  return api.post(`/invoice/${invoiceMasterId}/processFee`, processFee)
}

// OFFICEWORK FEE
export const getOfficeWorkFee = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/officeWorkFee`)
}

export const getOfficeWorkFeeOptions = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/officeWorkFee/officeWorkFeeOption`)
}

export const postOfficeWorkFee = (invoiceMasterId: string, req: OfficeWorkRequest[]) => {
  return api.post(`/invoice/${invoiceMasterId}/officeWorkFee`, req)
}

export const postOfficeWorkFeeOptions = (invoiceMasterId: string, req: OfficeWorkOptionRequest) => {
  return api.post(`/invoice/${invoiceMasterId}/officeWorkFee/officeWorkFeeOption`, req)
}

// WRAPPING FEE
export const getWrappingFee = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/wrappingFee`)
}

export const postWrappingFee = (invoiceMasterId: string, req: WrappingFeeRequestItem[]) => {
  return api.post(`/invoice/${invoiceMasterId}/wrappingFee`, req)
}

export const getSizeOptions = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/wrappingFee/wrappingSizeOption`)
}

export const postSizeOptions = (invoiceMasterId: string, req: WrappingSizeOptionRequest) => {
  return api.post(`/invoice/${invoiceMasterId}/wrappingFee/wrappingSizeOption`, req)
}

export const getDeliveryOptions = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/wrappingFee/deliveryMethodOption`)
}

export const postDeliveryOptions = (invoiceMasterId: string, req: WrappingDeliveryOptionRequest) => {
  return api.post(`/invoice/${invoiceMasterId}/wrappingFee/deliveryMethodOption`, req)
}

// LOGISTIC FEE
export const getLogisticFee = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/logisticFee`)
}

export const postLogisticFee = (invoiceMasterId: string, req: LogisticsFeeRequestItem[]) => {
  return api.post(`/invoice/${invoiceMasterId}/logisticFee`, req)
}

export const postLogisticFeeCSV = (invoiceMasterId: string, req: string[]) => {
  return api.post(`/invoice/${invoiceMasterId}/uploadLogisticFeeCSV`, req)
}

// INVOICE CONTENT
export const postInvoiceContent = (invoiceMasterId: string, req: InvoiceContentRequest[]) => {
  return api.post(`/invoice/${invoiceMasterId}/invoiceContent`, req) 
}

// TAX
export const getTaxRate = (date: string) => {
  return api.get(`/tax?date=${date}`)
}

// SHIPPING FEE
export const uploadSagawaCSV = (req: string[]) => {
  return api.post(`/invoice/shippingFee/uploadSagawaCSV`, req)
}

export const uploadYamatoCSV = (req: string[]) => {
  return api.post(`/invoice/shippingFee/uploadYamatoCSV`, req)
}

export const getShippingFee = (invoiceMasterId: string) => {
  return api.get(`/invoice/${invoiceMasterId}/shippingFee`);
};

export const postShippingFee = (invoiceMasterId: string, req:ShippingFeeRequestItem[]) => {
  return api.post(`/invoice/${invoiceMasterId}/shippingFee`, req);
};

// ARRIVAL DATA
export const getArrivalInformation = async (invoiceId: string | undefined) => {
  return api.get(`/invoice/${invoiceId}/arrivalData`);
}
